import moment from 'moment';

(() => {
  angular.module('pims').filter('age', () => {
    'ngInject';

    return date => {
      return moment().diff(moment(new Date(date)), 'years');
    };
  });
})();